
export enum LogType {
    Login = 1,
    Nav = 2,
    Open = 3,
    Click = 4,
    NavCarrusel = 5,
    NavNovelty = 6,
    Download = 7,
    Logout = 8
}
